import styled from 'styled-components';
import { fontHeadingMd } from '../../typography.styled';

export const AnnualRevenueEstimate = styled.div`
    display: flex;
    flex-wrap: nowrap;
    gap: 15px;
    align-items: center;

    svg {
        margin: auto;
    }

    span {
        ${fontHeadingMd};
        white-space: nowrap;
        margin: auto;
    }
`;
